export const requisites = {
    ogrn: '1245000090752',
    inn: '5003164750',
    kpp: '500301001',
    okpo: '54349495',
    oktao: '46407000000',
    okfs: '16, Частная собственность',
    oktmo: '46707000001',
    okogu: '4210014',
    okopf: '12300',
    registration_data: '09.08.2024',
    ur_address: '142715, Московская область, г Видное, промзона Северная Промзона, пр-д Проектируемый № 5208, зд. 3/3а, этаж/комната 1/3',
}

export const contacts = {
    sales_department_phone: '79252118444',
    // sales_department_phone_2: '79361994555',
    // commerce_department_phone: '78003502059',
    logistics_department_phone: '79361994555',
    info_mail: 'sale@dorozhnyeplity.ru',
    whatsapp: 'https://api.whatsapp.com/send/?phone=79268050897&text&type=phone_number&app_absent=0',
    telegram: 'https://t.me/dorozhnye_plity_bot',
    yandex_map_link: 'https://yandex.com/maps/-/CLUrVH7O',
    address: 'Москва, Домодедово, Промышленная ул. 38',
}
